import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal-trigger"
export default class extends Controller {
  static values = { target: String };

  launch(event) {
    const modal = document.querySelector(`[data-id="${this.targetValue}"]`);
    if (modal) {
      const modalController =
        this.application.getControllerForElementAndIdentifier(modal, "modal");
      modalController.open(event);
    }
  }

  secretLaunch(event) {
    const modal = document.querySelector(`[data-id="${this.targetValue}"]`);
    if (modal) {
      const modalController =
        this.application.getControllerForElementAndIdentifier(modal, "modal");
      modalController.open_secretly(event);
    }
  }
}
